<ng-container [formGroup]="parent">
  <ng-container formGroupName="header">
    <div class="d-flex justify-content-end align-items-center gap-3 mb-3">
      <!-- <div class="col-3 col-min-12">
        <div class="form-group has-float-label mb-4">
          <ng-select
            class="p-0"
            formControlName="templateId"
            (change)="onTemplateSelection()"
          >
            <ng-option *ngFor="let com of templates" [value]="com.id">
              {{ com.name }}
            </ng-option>
          </ng-select>
          <label class="form-label">Template Name</label>
        </div>
      </div> -->
      <!-- <div class="col-3 col-min-12" *ngIf="displaySaleOrderSection">
        <div class="form-group has-float-label mb-4">
          <input
            class="form-control"
            type="text"
            formControlName="saleOrderId"
          />
          <label class="form-label">Sale Order Id</label>
        </div>
      </div> -->

      <!-- <div class="col-3 col-min-12" *ngIf="displayWorkflowSection">
        <div class="form-group has-float-label mb-4">
          <input class="form-control" type="text" formControlName="workflowId" />
          <label class="form-label">PO #</label>
        </div>
      </div> -->
      <div>
        <div class="button-font">
          <!-- <button
            class="btn btn-primary"
            *ngIf="!!workflowJournalPdf"
            (click)="projectSummaryExcelDownload()"
            >Download Excel</button
          > -->

          <p-button
            label="Download Excel"
            *ngIf="!!workflowJournalPdf"
            (click)="projectSummaryExcelDownload()" />
        </div>
      </div>
      <div>
        <div class="button-font">
          <!-- <button
            class="btn btn-primary"
            *ngIf="!!workflowJournalPdf"
            (click)="onEmailSelection()"
            >Email</button
          > -->

          <p-button
            label="Email"
            *ngIf="!!workflowJournalPdf"
            (click)="onEmailSelection()" />
        </div>
      </div>
    </div>
    <div>
      <ngx-extended-pdf-viewer
        [base64Src]="workflowJournalPdf"
        [textLayer]="true"
        [showHandToolButton]="true"
        [showPresentationModeButton]="true"
        [filenameForDownload]="'Tracking-' + salesOrderId"
        height="75vh"></ngx-extended-pdf-viewer>
    </div>
  </ng-container>
</ng-container>
